import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import loteInformesService from '../../services/loteInformesService';

const DashboardLotesVencimientosWidget: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [vencidos, setVencidos] = useState(0);
  const [proximos, setProximos] = useState(0);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await loteInformesService.vencimientos({ dias: 30, page: 1, pageSize: 5 });
        if (cancelled) return;
        setVencidos(Number(res.resumen?.vencidos ?? 0));
        setProximos(Number(res.resumen?.proximos ?? 0));
        setVisible(true);
      } catch {
        if (!cancelled) setVisible(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loading && !visible) return null;

  return (
    <Card
      sx={{
        p: 2.5,
        height: '100%',
        borderRadius: 3,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        border: '1px solid #e0e0e0',
      }}
    >
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2', mb: 1 }}>
          Lotes vencidos / próximos
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary">
              Vencidos: <strong>{vencidos}</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Próximos (30 días): <strong>{proximos}</strong>
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={() => navigate('/inventario/informes/lotes-vencimientos')}
              sx={{ textTransform: 'none' }}
            >
              Ver vencimientos
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardLotesVencimientosWidget;
